const component = require('../component/component');

const timePlanning = Object.assign({}, component, {
    subelements: {
        slider: null,
    },
    start: 0,
    end: 100,
    intervals: [],
    itemComponentIds: [],
    startIsActive: false,
    handlesNo: -1,
    handlesNoComponent: false,
    step: 1,
    displayFormat: 'HH:mm',
    noUiSlider: false,
    tooltips: [],

    init: function () {
        component.init.call(this);

        this.createSlider();
    },

    inited: function () {
        if (this.handlesNoComponent !== false && typeof this.hm.app.components[this.handlesNoComponent] !== typeof undefined) {
            this.hm.app.components[this.handlesNoComponent].element.addEventListener('change', (e) => { this.createSlider(); });
        }
    },

    getHandlesNo: function () {
        if (this.handlesNoComponent !== false && typeof this.hm.app.components[this.handlesNoComponent] !== typeof undefined) {
            this.handlesNo = parseInt(this.hm.app.components[this.handlesNoComponent].getValue());
        }

        //this.hm.log('handlesNo', this.handlesNo);

        return this.handlesNo;
    },

    createSlider: function () {
        this.getHandlesNo();

        let start = [];
        let connect = [];
        let handlesCounter = 0;
        let lastOne = this.start;
        let connectVal = this.startIsActive;

        //this.hm.log('intervals', this.intervals);

        if (this.intervals.length > 0) {
            this.intervals.forEach((interval) => {
                if (handlesCounter === this.handlesNo) {
                    return false;
                }

                if (this.start !== interval[0]) {
                    start.push(interval[0]);
                    handlesCounter++;

                    connect.push(connectVal);
                    connectVal = !connectVal;
                }

                if (this.end !== interval[1]) {
                    start.push(interval[1]);
                    lastOne = interval[1];
                    handlesCounter++;

                    connect.push(connectVal);
                    connectVal = !connectVal;
                }
            });

            //this.hm.log('handles counter', handlesCounter, connect);

            if (handlesCounter < this.handlesNo && this.start === this.intervals[0][0]) {
                start.unshift(this.start);
                handlesCounter++;
                connect.push(connectVal);
                connectVal = !connectVal;
            }

            if (handlesCounter === this.handlesNo - 1 && this.end === this.intervals[this.intervals.length - 1][1]) {
                start.push(this.end);
                handlesCounter++;
                connect.push(connectVal);
                connectVal = !connectVal;
            }
        }

        let intervalLength = Math.floor((this.end + 1 - lastOne) / (this.handlesNo - handlesCounter + 1));

        for (let i = 0; i < this.handlesNo - handlesCounter; i++) {
            start.push(lastOne + intervalLength * (i + 1));
            connect.push(connectVal);
            connectVal = !connectVal;
        }

        connect.push(connectVal);

        if (this.noUiSlider !== false) {
            this.noUiSlider.destroy();
        }

        let tooltipsConfig = [];
        start.forEach(() => {
            tooltipsConfig.push({
                to: (value) => {
                    return this.hm.helper.seconds2time(value, this.displayFormat);
                }
            });
        });

        this.noUiSlider = noUiSlider.create(this.subelements.slider, {
            start: start,
            connect: connect,
            /*tooltips: {
                to: (value) => {
                    return this.hm.helper.seconds2time(value, this.displayFormat);
                }
            },*/
            tooltips: tooltipsConfig,
            range: {
                "min": this.start,
                "max": this.end
            },
            step: this.step
        });

        this.tooltips = this.noUiSlider.getTooltips();
        let origins = this.noUiSlider.getOrigins();

        // Move tooltips into the origin element. The default stylesheet handles this.
        this.tooltips.forEach(function (tooltip, index) {
            if (tooltip) {
                origins[index].appendChild(tooltip);
            }
        });

        this.noUiSlider.on('change', (values, handle, unencoded, tap, positions) => { this.saveIntervals(unencoded, positions); });

        this.noUiSlider.on('end', (values, handle, unencoded, tap, positions) => { this.updateOtherComponents(); })

        this.saveIntervals(start);
    },

    saveIntervals: function (values, positions) {
        //save intervals
        if (this.startIsActive) {
            values.unshift(this.start);
        }

        if (values.length % 2 === 1) {
            values.push(this.end);
        }

        this.intervals = [];

        for (let i = 0; i < values.length; i = i + 2) {
            this.intervals.push([parseInt(values[i]), parseInt(values[i + 1])]);
        }

        this.element.value = JSON.stringify(this.intervals);

        if (typeof positions === typeof undefined) {
            positions = this.noUiSlider.getPositions();
        }

        //solve tooltips merging
        let formattedValues = [];
        let separator = ' - ';
        let threshold = 5;

        values.forEach((value) => {
            formattedValues.push(this.hm.helper.seconds2time(value, this.displayFormat));
        })

        var pools = [[]];
        var poolPositions = [[]];
        var poolValues = [[]];
        var atPool = 0;

        // Assign the first tooltip to the first pool, if the tooltip is configured
        if (this.tooltips[0]) {
            pools[0][0] = 0;
            poolPositions[0][0] = positions[0];
            poolValues[0][0] = formattedValues[0];
        }

        for (var i = 1; i < positions.length; i++) {
            if (!this.tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
                atPool++;
                pools[atPool] = [];
                poolValues[atPool] = [];
                poolPositions[atPool] = [];
            }

            if (this.tooltips[i]) {
                pools[atPool].push(i);
                poolValues[atPool].push(formattedValues[i]);
                poolPositions[atPool].push(positions[i]);
            }
        }

        pools.forEach((pool, poolIndex) => {
            var handlesInPool = pool.length;

            for (var j = 0; j < handlesInPool; j++) {
                var handleNumber = pool[j];

                if (j === handlesInPool - 1) {
                    var offset = 0;

                    poolPositions[poolIndex].forEach((value) => {
                        offset += 1000 - value;
                    });

                    var direction = 'right';
                    var last = handlesInPool - 1;
                    var lastOffset = 1000 - poolPositions[poolIndex][last];
                    offset = (offset / handlesInPool) - lastOffset;

                    // Center this tooltip over the affected handles
                    this.tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
                    // Show by removing the theme-mapped displayNone class (was style.display='block').
                    this.hm.helper.showElement(this.tooltips[handleNumber]);
                    this.tooltips[handleNumber].style[direction] = offset + '%';
                } else {
                    // Hide via the theme-mapped displayNone class (was style.display='none').
                    this.hm.helper.hideElement(this.tooltips[handleNumber]);
                }
            }
        });
    },

    updateOtherComponents: function () {
        if (this.itemComponentIds.length > 0) {
            for (let i = 0; i < this.itemComponentIds.length; i++) {
                let componentId = this.itemComponentIds[i];

                if (typeof this.hm.app.components[componentId] !== typeof undefined) {
                    let component = this.hm.app.components[componentId];
                    let intervalIndex = Math.floor(i / 2);

                    component.setValue(this.intervals[intervalIndex][i % 2 == 0 ? 0 : 1]);
                }
            }
        }
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }

        return this.intervals;
    },
});


module.exports = timePlanning;